var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _polygon2, _rect, _rect2, _polygon3, _polygon4, _line, _polyline, _polyline2, _line2, _line3, _line4, _line5, _polyline3, _rect3, _rect4, _rect5, _g, _rect6, _rect7, _polygon5, _polygon6, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _polygon7, _polygon8, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _rect8, _line20, _line21, _line22, _line23, _line24, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _line25, _line26, _polyline4, _path17, _path18, _line27, _path19, _path20, _path21, _g2, _g3, _g4, _g5, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _polygon9, _polygon10, _rect9, _rect10, _polygon11, _polygon12, _line28, _polyline5, _polyline6, _line29, _line30, _line31, _line32, _polyline7, _rect11, _rect12, _rect13, _g6, _rect14, _rect15, _polygon13, _polygon14, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _polygon15, _polygon16, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _rect16, _line47, _line48, _line49, _line50, _line51, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _line52, _line53, _polyline8, _path38, _path39, _line54, _path40, _path41, _path42, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-kpi-3{fill:none;}\n\t.st1-kpi-3{fill:#BFE7F8;}\n\t.st2-kpi-3{fill:#009FE3;}\n\t.st3-kpi-3{fill:none;stroke:#00598E;stroke-width:3.3402;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4-kpi-3{fill:#F2FAFE;}\n\t.st5-kpi-3{fill:none;stroke:#00598E;stroke-width:3.3402;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6-kpi-3{fill:none;stroke:#009FE3;stroke-width:3.3402;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7-kpi-3{fill:none;stroke:#00598E;stroke-width:3.3402;stroke-miterlimit:10;}\n\t.st8-kpi-3{fill:#009FE3;stroke:#00598E;stroke-width:3;stroke-miterlimit:10;}\n\t.st9-kpi-3{fill:#FFFFFF;stroke:#00598E;stroke-width:3.34;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10-kpi-3{fill:#FFFFFF;stroke:#00598E;stroke-width:3;stroke-miterlimit:10;}\n\t.st11-kpi-3{fill:none;stroke:#00598E;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0-kpi-3",
    d: "M10,939.8h1780c11,0,20-9,20-20V160.2c0-11-9-20-20-20H10c-11,0-20,9-20,20v759.5C-10,930.8-1,939.8,10,939.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1-kpi-3",
    d: "M1779.5,822.6H695l0,0c0-59.3,48-107.3,107.3-107.3h869.9C1731.5,715.3,1779.5,763.4,1779.5,822.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1-kpi-3",
    d: "M1247.5,822.6h532c0,59.3-48.1,107.3-107.3,107.3h-317.3C1295.6,929.9,1247.5,881.9,1247.5,822.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2-kpi-3",
    d: "M1577.6,599.6c0,21-17,38-38,38s-38-17-38-38s17-38,38-38S1577.6,578.6,1577.6,599.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3-kpi-3",
    d: "M1577.6,599.6c0,21-17,38-38,38s-38-17-38-38s17-38,38-38S1577.6,578.6,1577.6,599.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M1558.8,524.8c0,39.6-32.1,71.7-71.7,71.7s-71.7-32.1-71.7-71.7s32.1-71.7,71.7-71.7 C1526.7,453.1,1558.8,485.2,1558.8,524.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2-kpi-3",
    d: "M1523.9,477.5c1.7,5.6,2.6,11.5,2.6,17.6c0,33.5-27.2,60.7-60.7,60.7c-13.7,0-26.4-4.6-36.6-12.2 c7.6,24.9,30.7,43.1,58.1,43.1c33.5,0,60.7-27.2,60.7-60.7C1548,506.2,1538.6,488.6,1523.9,477.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3-kpi-3",
    d: "M1558.8,524.8c0,39.6-32.1,71.7-71.7,71.7s-71.7-32.1-71.7-71.7s32.1-71.7,71.7-71.7 C1526.7,453.1,1558.8,485.2,1558.8,524.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3-kpi-3",
    points: "1489.7,729.8 1489.7,729.8 1489.7,564.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3-kpi-3",
    points: "1489.7,661 1489.7,661 1536.5,614.2 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 860.7,
    y: 569,
    className: "st4-kpi-3",
    width: 360.8,
    height: 158.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 860.7,
    y: 569,
    className: "st5-kpi-3",
    width: 360.8,
    height: 158.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4-kpi-3",
    points: "1455.2,727.7 1138.4,727.7 1138.4,435.8 1455.2,379.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5-kpi-3",
    points: "1453.1,727.7 1136.3,727.7 1136.3,435.8 1453.1,379.7 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1136.3,
    y1: 422,
    x2: 1453.1,
    y2: 365.9
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2-kpi-3",
    points: "1169.7,725.7 1169.7,593.3 1221.5,593.3 1221.5,725.7 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "1169.7,725.7 1169.7,592 1221.5,592 1221.5,725.7 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 822.5,
    y1: 569,
    x2: 885.8,
    y2: 569
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6-kpi-3",
    x1: 888.6,
    y1: 695.2,
    x2: 1105.5,
    y2: 695.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st6-kpi-3",
    x1: 888.6,
    y1: 661.1,
    x2: 1105.5,
    y2: 661.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st6-kpi-3",
    x1: 888.6,
    y1: 627,
    x2: 1105.5,
    y2: 627
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "888.6,727.7 888.6,598.3 1105.5,598.3 1105.5,727.7 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1287.8,
    y: 471.3,
    className: "st2-kpi-3",
    width: 120.7,
    height: 89.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1287.8,
    y: 593.3,
    className: "st2-kpi-3",
    width: 120.7,
    height: 52.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1287.8,
    y: 593.3,
    className: "st5-kpi-3",
    width: 120.7,
    height: 52.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1169.6,
    y: 471.3,
    className: "st2-kpi-3",
    width: 51.8,
    height: 89.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1169.7,
    y: 471.3,
    className: "st5-kpi-3",
    width: 51.8,
    height: 89.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "1169.7,516.1 1239.4,516.1 1239.4,561 1223.2,561  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1187.3,
    y1: 516.1,
    x2: 1187.3,
    y2: 561
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1203.8,
    y1: 516.1,
    x2: 1203.8,
    y2: 561
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1171.9,
    y: 478.6,
    className: "st0-kpi-3",
    width: 46.9,
    height: 84.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1290.6,
    y: 478.6,
    className: "st0-kpi-3",
    width: 115.2,
    height: 84.8
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4-kpi-3",
    points: "968.3,543.6 884.8,543.6 915.1,485 998.6,485 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7-kpi-3",
    points: "968.3,543.6 884.8,543.6 915.1,485 998.6,485 "
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 942.7,
    y1: 485,
    x2: 912.5,
    y2: 543.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 942.7,
    y1: 485,
    x2: 912.5,
    y2: 543.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 983.4,
    y1: 514.3,
    x2: 898.3,
    y2: 514.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 970.9,
    y1: 485,
    x2: 940.6,
    y2: 543.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 970.9,
    y1: 485,
    x2: 940.6,
    y2: 543.6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 912.5,
    y1: 549.1,
    x2: 912.5,
    y2: 569
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 940.9,
    y1: 549.1,
    x2: 940.9,
    y2: 569
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4-kpi-3",
    points: "1076.3,543.6 992.8,543.6 1023.1,485 1106.6,485 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7-kpi-3",
    points: "1076.3,543.6 992.8,543.6 1023.1,485 1106.6,485 "
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 1050.7,
    y1: 485,
    x2: 1020.5,
    y2: 543.6
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 1050.7,
    y1: 485,
    x2: 1020.5,
    y2: 543.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 1091.4,
    y1: 514.3,
    x2: 1006.3,
    y2: 514.3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 1078.9,
    y1: 485,
    x2: 1048.6,
    y2: 543.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 1078.9,
    y1: 485,
    x2: 1048.6,
    y2: 543.6
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 1020.5,
    y1: 549.1,
    x2: 1020.5,
    y2: 569
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 1048.9,
    y1: 549.1,
    x2: 1048.9,
    y2: 569
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1241.4,
    y: 593.3,
    className: "st5-kpi-3",
    width: 20.6,
    height: 10.3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1675,
    y1: 849.7,
    x2: 1280.5,
    y2: 849.7
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1267.8,
    y1: 849.7,
    x2: 1242.6,
    y2: 849.7
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1234.8,
    y1: 849.7,
    x2: 1227.7,
    y2: 849.7
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1752.6,
    y1: 849.8,
    x2: 1708.9,
    y2: 849.8
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1697.6,
    y1: 849.8,
    x2: 1687.7,
    y2: 849.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M1391.3,813h268.2c10.2,0,18.4-4.9,18.4-15.1v-11.3c0-35.1-19.9-53.8-50.2-53.8h-11.8c-10,0-10.9-2.3-14.6-6.4 c-13.3-14.5-34.5-48.5-78.8-48.5h-56.3c-54.7,0-99.1,44.4-99.1,99.1v11.7C1367,802.1,1377.9,813,1391.3,813"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1391.3,813h268.2c10.2,0,18.4-4.9,18.4-15.1v-11.3c0-35.1-19.9-53.8-50.2-53.8h-11.8c-10,0-10.9-2.3-14.6-6.4 c-13.3-14.5-34.5-48.5-78.8-48.5h-56.3c-54.7,0-99.1,44.4-99.1,99.1v11.7C1367,802.1,1377.9,813,1391.3,813z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M1462.3,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1S1462.3,791.3,1462.3,811.8 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1462.3,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1S1462.3,791.3,1462.3,811.8 z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1443.6,811.8c0,10.1-8.2,18.3-18.3,18.3c-10.1,0-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3 C1435.4,793.4,1443.6,801.6,1443.6,811.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M1659,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1 C1642.3,774.7,1659,791.3,1659,811.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1659,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1 C1642.3,774.7,1659,791.3,1659,811.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1640.2,811.8c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3 C1632,793.4,1640.2,801.6,1640.2,811.8z"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1487.4,
    y1: 745.4,
    x2: 1487.4,
    y2: 811.8
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1498.4,
    y1: 741,
    x2: 1515.2,
    y2: 741
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "1367,781 1380.2,781 1380.2,763.9 1369.3,763.9 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1669.3,755.9h-5c-4.1,0-7.2,3.9-6.1,7.9l3.1,11.8c0.9,3.2,3.8,5.5,7.1,5.5h9.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1396,729.8h188.8c-9.7-23.5-39.7-44.1-66.6-42.6h-55.9C1438.8,687.2,1403.8,708.5,1396,729.8z"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 1487.4,
    y1: 688.3,
    x2: 1487.4,
    y2: 718.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7-kpi-3",
    d: "M1419.4,752.7c0,6.5-5.3,11.7-11.7,11.7c-6.5,0-11.7-5.3-11.7-11.7c0-6.5,5.3-11.7,11.7-11.7 C1414.2,741,1419.4,746.2,1419.4,752.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1251.7,697.6v97.6c0,7.8,6.3,14.2,14.2,14.2h61.7c7.8,0,14.2-6.3,14.2-14.2c0-7.8-6.3-14.2-14.2-14.2 c-7.8,0-14.2-6.3-14.2-14.2c0-7.8,6.3-14.2,14.2-14.2h80.2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M1259.8,708.5h-16.2c-2.7,0-4.9-2.2-4.9-4.9v-16.2c0-2.7,2.2-4.9,4.9-4.9h16.2c2.7,0,4.9,2.2,4.9,4.9v16.2 C1264.7,706.3,1262.5,708.5,1259.8,708.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000091695467356378479110000000250363737112681863_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8-kpi-3",
    d: "M1305.7,742.9h-7.7c-0.8,0-1.5-0.7-1.5-1.5V730c0-0.8,0.7-1.5,1.5-1.5h7.7c0.8,0,1.5,0.7,1.5,1.5v11.4 C1307.1,742.3,1306.4,742.9,1305.7,742.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8-kpi-3",
    d: "M1341,742.9h-7.7c-0.8,0-1.5-0.7-1.5-1.5V730c0-0.8,0.7-1.5,1.5-1.5h7.7c0.8,0,1.5,0.7,1.5,1.5v11.4 C1342.5,742.3,1341.8,742.9,1341,742.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9-kpi-3",
    d: "M1293.3,734.6h50.8c3.6,0,6.4-2.9,6.4-6.4v-55.8c0-3.6-2.9-6.4-6.4-6.4h-50.8c-3.6,0-6.4,2.9-6.4,6.4v55.8 C1286.8,731.7,1289.7,734.6,1293.3,734.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8-kpi-3",
    cx: 1313.2,
    cy: 702.7,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10-kpi-3",
    cx: 1313.2,
    cy: 702.7,
    r: 6.1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st10-kpi-3",
    cx: 1296.7,
    cy: 657.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11-kpi-3",
    x1: 1296.7,
    y1: 660.8,
    x2: 1296.7,
    y2: 665
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10-kpi-3",
    cx: 1308.9,
    cy: 657.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11-kpi-3",
    x1: 1308.9,
    y1: 660.8,
    x2: 1308.9,
    y2: 665
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1287.8,
    y: 471.3,
    className: "st5-kpi-3",
    width: 120.7,
    height: 89.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11-kpi-3",
    d: "M1341,694c9,8,19,2,27-3c5-3,10-1,15,3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11-kpi-3",
    d: "M1341,686c9,8,19,2,27-3c5-3,10-1,15,3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11-kpi-3",
    d: "M1341,678c9,8,19,2,27-3c5-3,10-1,15,3"
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0-kpi-3",
    d: "M1950,939.8h1780c11,0,20-9,20-20V160.2c0-11-9-20-20-20H1950c-11,0-20,9-20,20v759.5 C1930,930.8,1939,939.8,1950,939.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1-kpi-3",
    d: "M3719.5,822.6H2635l0,0c0-59.3,48-107.3,107.3-107.3h869.9C3671.5,715.3,3719.5,763.4,3719.5,822.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1-kpi-3",
    d: "M3187.5,822.6h532c0,59.3-48.1,107.3-107.3,107.3h-317.3C3235.6,929.9,3187.5,881.9,3187.5,822.6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2-kpi-3",
    d: "M3517.6,599.6c0,21-17,38-38,38s-38-17-38-38s17-38,38-38S3517.6,578.6,3517.6,599.6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st3-kpi-3",
    d: "M3517.6,599.6c0,21-17,38-38,38s-38-17-38-38s17-38,38-38S3517.6,578.6,3517.6,599.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M3498.8,524.8c0,39.6-32.1,71.7-71.7,71.7s-71.7-32.1-71.7-71.7s32.1-71.7,71.7-71.7 C3466.7,453.1,3498.8,485.2,3498.8,524.8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2-kpi-3",
    d: "M3463.9,477.5c1.7,5.6,2.6,11.5,2.6,17.6c0,33.5-27.2,60.7-60.7,60.7c-13.7,0-26.4-4.6-36.6-12.2 c7.6,24.9,30.7,43.1,58.1,43.1c33.5,0,60.7-27.2,60.7-60.7C3488,506.2,3478.6,488.6,3463.9,477.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3-kpi-3",
    d: "M3498.8,524.8c0,39.6-32.1,71.7-71.7,71.7s-71.7-32.1-71.7-71.7s32.1-71.7,71.7-71.7 C3466.7,453.1,3498.8,485.2,3498.8,524.8z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3-kpi-3",
    points: "3429.7,729.8 3429.7,729.8 3429.7,564.2 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3-kpi-3",
    points: "3429.7,661 3429.7,661 3476.5,614.2 "
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2800.7,
    y: 569,
    className: "st4-kpi-3",
    width: 360.8,
    height: 158.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2800.7,
    y: 569,
    className: "st5-kpi-3",
    width: 360.8,
    height: 158.7
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4-kpi-3",
    points: "3395.2,727.7 3078.4,727.7 3078.4,435.8 3395.2,379.7 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5-kpi-3",
    points: "3393.1,727.7 3076.3,727.7 3076.3,435.8 3393.1,379.7 "
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3076.3,
    y1: 422,
    x2: 3393.1,
    y2: 365.9
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2-kpi-3",
    points: "3109.7,725.7 3109.7,593.3 3161.5,593.3 3161.5,725.7 "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "3109.7,725.7 3109.7,592 3161.5,592 3161.5,725.7 "
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 2762.5,
    y1: 569,
    x2: 2825.8,
    y2: 569
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st6-kpi-3",
    x1: 2828.6,
    y1: 695.2,
    x2: 3045.5,
    y2: 695.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st6-kpi-3",
    x1: 2828.6,
    y1: 661.1,
    x2: 3045.5,
    y2: 661.1
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st6-kpi-3",
    x1: 2828.6,
    y1: 627,
    x2: 3045.5,
    y2: 627
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "2828.6,727.7 2828.6,598.3 3045.5,598.3 3045.5,727.7 "
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3227.8,
    y: 471.3,
    className: "st2-kpi-3",
    width: 120.7,
    height: 89.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3227.8,
    y: 593.3,
    className: "st2-kpi-3",
    width: 120.7,
    height: 52.6
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 3227.8,
    y: 593.3,
    className: "st5-kpi-3",
    width: 120.7,
    height: 52.6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3109.6,
    y: 471.3,
    className: "st2-kpi-3",
    width: 51.8,
    height: 89.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3109.7,
    y: 471.3,
    className: "st5-kpi-3",
    width: 51.8,
    height: 89.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "3109.7,516.1 3179.4,516.1 3179.4,561 3163.2,561  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3127.3,
    y1: 516.1,
    x2: 3127.3,
    y2: 561
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3143.8,
    y1: 516.1,
    x2: 3143.8,
    y2: 561
  })))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 3111.9,
    y: 478.6,
    className: "st0-kpi-3",
    width: 46.9,
    height: 84.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 3230.6,
    y: 478.6,
    className: "st0-kpi-3",
    width: 115.2,
    height: 84.8
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4-kpi-3",
    points: "2908.3,543.6 2824.8,543.6 2855.1,485 2938.6,485 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7-kpi-3",
    points: "2908.3,543.6 2824.8,543.6 2855.1,485 2938.6,485 "
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 2882.7,
    y1: 485,
    x2: 2852.5,
    y2: 543.6
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2882.7,
    y1: 485,
    x2: 2852.5,
    y2: 543.6
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2923.4,
    y1: 514.3,
    x2: 2838.3,
    y2: 514.3
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 2910.9,
    y1: 485,
    x2: 2880.6,
    y2: 543.6
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2910.9,
    y1: 485,
    x2: 2880.6,
    y2: 543.6
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2852.5,
    y1: 549.1,
    x2: 2852.5,
    y2: 569
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2880.9,
    y1: 549.1,
    x2: 2880.9,
    y2: 569
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4-kpi-3",
    points: "3016.3,543.6 2932.8,543.6 2963.1,485 3046.6,485 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7-kpi-3",
    points: "3016.3,543.6 2932.8,543.6 2963.1,485 3046.6,485 "
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 2990.7,
    y1: 485,
    x2: 2960.5,
    y2: 543.6
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2990.7,
    y1: 485,
    x2: 2960.5,
    y2: 543.6
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 3031.4,
    y1: 514.3,
    x2: 2946.3,
    y2: 514.3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st0-kpi-3",
    x1: 3018.9,
    y1: 485,
    x2: 2988.6,
    y2: 543.6
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 3018.9,
    y1: 485,
    x2: 2988.6,
    y2: 543.6
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2960.5,
    y1: 549.1,
    x2: 2960.5,
    y2: 569
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st7-kpi-3",
    x1: 2988.9,
    y1: 549.1,
    x2: 2988.9,
    y2: 569
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 3181.4,
    y: 593.3,
    className: "st5-kpi-3",
    width: 20.6,
    height: 10.3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3615,
    y1: 849.7,
    x2: 3220.5,
    y2: 849.7
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3207.8,
    y1: 849.7,
    x2: 3182.6,
    y2: 849.7
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3174.8,
    y1: 849.7,
    x2: 3167.7,
    y2: 849.7
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3692.6,
    y1: 849.8,
    x2: 3648.9,
    y2: 849.8
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3637.6,
    y1: 849.8,
    x2: 3627.7,
    y2: 849.8
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M3331.3,813h268.2c10.2,0,18.4-4.9,18.4-15.1v-11.3c0-35.1-19.9-53.8-50.2-53.8h-11.8c-10,0-10.9-2.3-14.6-6.4 c-13.3-14.5-34.5-48.5-78.8-48.5h-56.3c-54.7,0-99.1,44.4-99.1,99.1v11.7C3307,802.1,3317.9,813,3331.3,813"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3331.3,813h268.2c10.2,0,18.4-4.9,18.4-15.1v-11.3c0-35.1-19.9-53.8-50.2-53.8h-11.8c-10,0-10.9-2.3-14.6-6.4 c-13.3-14.5-34.5-48.5-78.8-48.5h-56.3c-54.7,0-99.1,44.4-99.1,99.1v11.7C3307,802.1,3317.9,813,3331.3,813z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M3402.3,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1S3402.3,791.3,3402.3,811.8 "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3402.3,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1S3402.3,791.3,3402.3,811.8 z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3383.6,811.8c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3 C3375.4,793.4,3383.6,801.6,3383.6,811.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4-kpi-3",
    d: "M3599,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1 C3582.3,774.7,3599,791.3,3599,811.8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3599,811.8c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1 C3582.3,774.7,3599,791.3,3599,811.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3580.2,811.8c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3 C3572,793.4,3580.2,801.6,3580.2,811.8z"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3427.4,
    y1: 745.4,
    x2: 3427.4,
    y2: 811.8
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3438.4,
    y1: 741,
    x2: 3455.2,
    y2: 741
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5-kpi-3",
    points: "3307,781 3320.2,781 3320.2,763.9 3309.3,763.9 "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3609.3,755.9h-5c-4.1,0-7.2,3.9-6.1,7.9l3.1,11.8c0.9,3.2,3.8,5.5,7.1,5.5h9.3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3336,729.8h188.8c-9.7-23.5-39.7-44.1-66.6-42.6h-55.9C3378.8,687.2,3343.8,708.5,3336,729.8z"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "st5-kpi-3",
    x1: 3427.4,
    y1: 688.3,
    x2: 3427.4,
    y2: 718.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st7-kpi-3",
    d: "M3359.4,752.7c0,6.5-5.3,11.7-11.7,11.7c-6.5,0-11.7-5.3-11.7-11.7c0-6.5,5.3-11.7,11.7-11.7 C3354.2,741,3359.4,746.2,3359.4,752.7z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3191.7,697.6v97.6c0,7.8,6.3,14.2,14.2,14.2h61.7c7.8,0,14.2-6.3,14.2-14.2c0-7.8-6.3-14.2-14.2-14.2 c-7.8,0-14.2-6.3-14.2-14.2c0-7.8,6.3-14.2,14.2-14.2h80.2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5-kpi-3",
    d: "M3199.8,708.5h-16.2c-2.7,0-4.9-2.2-4.9-4.9v-16.2c0-2.7,2.2-4.9,4.9-4.9h16.2c2.7,0,4.9,2.2,4.9,4.9v16.2 C3204.7,706.3,3202.5,708.5,3199.8,708.5z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8-kpi-3",
    d: "M3245.7,742.9h-7.7c-0.8,0-1.5-0.7-1.5-1.5V730c0-0.8,0.7-1.5,1.5-1.5h7.7c0.8,0,1.5,0.7,1.5,1.5v11.4 C3247.1,742.3,3246.4,742.9,3245.7,742.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8-kpi-3",
    d: "M3281,742.9h-7.7c-0.8,0-1.5-0.7-1.5-1.5V730c0-0.8,0.7-1.5,1.5-1.5h7.7c0.8,0,1.5,0.7,1.5,1.5v11.4 C3282.5,742.3,3281.8,742.9,3281,742.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9-kpi-3",
    d: "M3233.3,734.6h50.8c3.6,0,6.4-2.9,6.4-6.4v-55.8c0-3.6-2.9-6.4-6.4-6.4h-50.8c-3.6,0-6.4,2.9-6.4,6.4v55.8 C3226.8,731.7,3229.7,734.6,3233.3,734.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8-kpi-3",
    cx: 3253.2,
    cy: 702.7,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10-kpi-3",
    cx: 3253.2,
    cy: 702.7,
    r: 6.1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3227.8,
    y: 471.3,
    className: "st5-kpi-3",
    width: 120.7,
    height: 89.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiThree);
export default __webpack_public_path__ + "static/media/kpi-three.1bd33be77b88de578fa1e26de96ea284.svg";
export { ForwardRef as ReactComponent };